import { siteData } from "./siteData";

const SiteView = () => import("@/views/site/index.vue");

function createRoute(path, sitePath, title, pageType, pageKey) {
  return {
    path,
    component: SiteView,
    hidden: true,
    meta: { title, publicPage: true },
    props: {
      sitePath,
      pageType,
      pageKey: pageKey || "",
    },
  };
}

const baseRoutes = [
  createRoute("/site", "/", "官网首页", "home"),
  createRoute("/site/product", "/product", "产品总览", "productIndex"),
  createRoute(
    "/site/product/openclaw",
    "/product/openclaw",
    "OpenClaw支持",
    "productDetail",
    "openclaw"
  ),
  createRoute("/site/solutions", "/solutions", "解决方案", "solutionsIndex"),
  createRoute("/site/customers", "/customers", "客户案例", "customersIndex"),
  createRoute("/site/pricing", "/pricing", "价格与版本", "pricing"),
  createRoute("/site/download", "/download", "App下载", "download"),
  createRoute("/site/resources", "/resources", "资源中心", "resourcesIndex"),
  createRoute(
    "/site/resources/templates",
    "/resources/templates",
    "模板下载",
    "templates"
  ),
  createRoute(
    "/site/resources/webinars",
    "/resources/webinars",
    "公开课",
    "webinars"
  ),
  createRoute(
    "/site/resources/updates",
    "/resources/updates",
    "产品更新",
    "updates"
  ),
  createRoute("/site/services", "/services", "服务与交付", "servicesIndex"),
  createRoute(
    "/site/services/onboarding",
    "/services/onboarding",
    "试用陪跑",
    "onboarding"
  ),
  createRoute(
    "/site/services/success",
    "/services/success",
    "客户成功",
    "success"
  ),
  createRoute("/site/about", "/about", "关于我们", "about"),
  createRoute("/site/signup", "/signup", "免费试用", "signup"),
  createRoute(
    "/site/signup/success",
    "/signup/success",
    "试用成功",
    "signupSuccess"
  ),
  createRoute("/site/login", "/login", "登录", "login"),
  createRoute(
    "/site/legal/terms",
    "/legal/terms",
    "服务协议",
    "legal",
    "terms"
  ),
  createRoute(
    "/site/legal/privacy",
    "/legal/privacy",
    "隐私政策",
    "legal",
    "privacy"
  ),
];

const productRoutes = siteData.modules.map((item) =>
  createRoute(
    `/site/product/${item.key}`,
    `/product/${item.key}`,
    item.title,
    "productDetail",
    item.key
  )
);

const solutionRoutes = siteData.solutions.map((item) =>
  createRoute(
    `/site/solutions/${item.key}`,
    `/solutions/${item.key}`,
    item.title,
    "solutionDetail",
    item.key
  )
);

const customerRoutes = siteData.customers.map((item) =>
  createRoute(
    `/site/customers/${item.id}`,
    `/customers/${item.id}`,
    item.title,
    "customerDetail",
    item.id
  )
);

const articleRoutes = siteData.resources.articles.map((item) =>
  createRoute(
    `/site/resources/articles/${item.id}`,
    `/resources/articles/${item.id}`,
    item.title,
    "article",
    item.id
  )
);

const siteRoutes = [
  ...baseRoutes,
  ...productRoutes,
  ...solutionRoutes,
  ...customerRoutes,
  ...articleRoutes,
];

export default siteRoutes;
